import { Button, Image, View } from "@/components/ui";
import { Typography } from "@/components/shared/typography";
import { ArrowFatRight } from "@/components/shared/icons";
import PersonWithPhone from "@/assets/images/3d-icons/person-with-phone.png";
import CalendarCheck from "@/assets/images/3d-icons/calendar-checklist.png";
import Gift from "@/assets/images/3d-icons/gift.png";
import { Fragment } from "react";
import { useRoute } from "@/components/shared/router";
import { openBrowser } from "@/lib/open-browser";
import { links } from "@/constants";

const HOW_IT_WORKS_ITEMS = [
  {
    icon: PersonWithPhone,
    title: "Invite your friends",
  },
  {
    icon: CalendarCheck,
    title: "They book their first session",
  },
  {
    icon: Gift,
    title: "You earn $15 Credit",
  },
];

export function ReferralSectionHowItWorks() {
  const { push } = useRoute();

  return (
    <>
      <View className="px-4 pt-14">
        <View className="mb-3 flex flex-row items-center justify-between">
          <Typography variant="label-md" color="foreground-default">
            How It Works
          </Typography>
          <Button
            variant="secondary"
            color="CTA2"
            size={"sm"}
            rounded="full"
            onClick={() => openBrowser(links.referringFriendHelpCentreLink)}
            iconAlignment={"end"}
            iconName="arrowUpRight"
            iconColor="CTA2"
            iconSize={"sm"}
          >
            Learn more
          </Button>
        </View>
        <View className="mb-3 rounded-lg bg-brand-primary-surface p-2">
          <View className="flex flex-row items-center gap-2">
            {HOW_IT_WORKS_ITEMS.map((item, index) => (
              <Fragment key={index}>
                <View className="flex flex-1 flex-col items-center gap-2">
                  <Image
                    src={item.icon}
                    alt={item.title}
                    width={48}
                    height={48}
                  />
                  <Typography
                    variant="body-sm"
                    color="foreground-default"
                    className="text-center"
                  >
                    {item.title}
                  </Typography>
                </View>
                {index !== HOW_IT_WORKS_ITEMS.length - 1 && (
                  <ArrowFatRight
                    size={20}
                    weight="fill"
                    className="text-brand-primary"
                  />
                )}
              </Fragment>
            ))}
          </View>
        </View>
        <View className="flex flex-col items-center">
          <Button
            variant="secondary"
            color="CTA2"
            size={"md"}
            rounded="full"
            onClick={() => push({ pageKey: "creditAccount" })}
            iconAlignment={"end"}
            iconName="arrowUpRight"
            iconColor="CTA2"
            iconSize={"md"}
          >
            See my credits
          </Button>
        </View>
      </View>
    </>
  );
}
